export const dataExperiencia = [
    {
        id: 1,
        title: 'Merefsa',
        ubicación: 'Barcelona',
        fecha: 'Abr 2021 - Ago 2022',
        puesto: 'Mozo de almacén'
    },
    {
        id: 2,
        title: 'Condis Supermercats',
        ubicación: 'Rubi, Barcelona',
        fecha: 'Feb 2018 - Mar 2021',
        puesto: 'Cajero repositor polivalente'
    },
    {
        id: 3,
        title: 'Servicios y Mantenimientos',
        ubicación: 'Rosario, Santa Fe, Argentina',
        fecha: 'Abr 2021 - Ago 2022',
        puesto: 'Técnico electricista'
    },
    {
        id: 4,
        title: 'Modelo Electro S.A.',
        ubicación: 'Rosario, Santa Fe, Argentina',
        fecha: 'Abr 2006 - Feb 2009',
        puesto: 'Administrativo'
    }
]